/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate } from './VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate';
import {
  VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreateFromJSON,
  VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreateFromJSONTyped,
  VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreateToJSON,
} from './VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate';
import type { VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate } from './VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate';
import {
  VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreateFromJSON,
  VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreateFromJSONTyped,
  VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreateToJSON,
} from './VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate';

/**
 * @type VoiceAgentInferencerCreatePolymorphic
 *
 * @export
 */
export type VoiceAgentInferencerCreatePolymorphic =
  | ({ protocol: 'CELINA' } & VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate)
  | ({ protocol: 'LIVEKIT' } & VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreate);

export function VoiceAgentInferencerCreatePolymorphicFromJSON(json: any): VoiceAgentInferencerCreatePolymorphic {
  return VoiceAgentInferencerCreatePolymorphicFromJSONTyped(json, false);
}

export function VoiceAgentInferencerCreatePolymorphicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoiceAgentInferencerCreatePolymorphic {
  if (json == null) {
    return json;
  }
  switch (json['protocol']) {
    case 'CELINA':
      return Object.assign(
        {},
        VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreateFromJSONTyped(json, true),
        { protocol: 'CELINA' } as const,
      );
    case 'LIVEKIT':
      return Object.assign(
        {},
        VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreateFromJSONTyped(json, true),
        { protocol: 'LIVEKIT' } as const,
      );
    default:
      throw new Error(`No variant of VoiceAgentInferencerCreatePolymorphic exists with 'protocol=${json['protocol']}'`);
  }
}

export function VoiceAgentInferencerCreatePolymorphicToJSON(value?: VoiceAgentInferencerCreatePolymorphic | null): any {
  if (value == null) {
    return value;
  }
  switch (value['protocol']) {
    case 'CELINA':
      return VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreateToJSON(value);
    case 'LIVEKIT':
      return VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerLiveKitCreateToJSON(value);
    default:
      throw new Error(
        `No variant of VoiceAgentInferencerCreatePolymorphic exists with 'protocol=${value['protocol']}'`,
      );
  }
}
